export default __webpack_public_path__ + "static/media/step_H_UA.456f9680.png";